import { createDatasetPanel as createDatasetPanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'

export const openCreateDatasetPanel = async (
  { hostname, editorSdkProxy, i18n },
  { componentRef, isDatasetTargetingInput },
) =>
  editorSdkProxy.editor.openToolPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: createDatasetPanelDef.url,
      editorSdkProxy,
    }),
    title: i18n.t('CONNECT_PANEL_CREATE_DATASET_PANEL_TITLE'),
    initialData: {
      componentRef,
      isDatasetTargetingInput,
    },
    width: 288,
    height: 325,
    noPanelPadding: true,
  })
